<script lang="ts" setup>
  import ButtonDefault from '@/elements/ButtonDefault.vue'
  import { FeatureFlagJsonldDefaultRead } from '@/api'

  interface EditNotesDialogProps {
    flag: FeatureFlagJsonldDefaultRead
  }

  const props = defineProps<EditNotesDialogProps>()
  const { flag } = toRefs(props)

  const emit = defineEmits(['submit'])

  const isVisible = defineModel<boolean>('isVisible', { required: true })
  const notes = ref<string>('')

  const isLoading = ref<boolean>(true)

  onMounted(() => {
    notes.value = flag.value.notes!
    isLoading.value = false
  })

  const onSubmit = () => {
    emit('submit', { notes: notes.value, id: flag.value.id })
  }
</script>

<template>
  <Dialog
    v-if="isVisible"
    v-model:visible="isVisible"
    header="Notes bearbeiten"
    modal>
    <form @submit.prevent="onSubmit">
      <div class="w-full mt-2">
        <Editor
          v-model="notes"
          editorStyle="height: 150px" />
      </div>
      <div class="mt-2 w-full flex justify-end">
        <ButtonDefault label="Absenden" icon="SubmitIcon" outlined size="small" type="submit" />
      </div>
    </form>
  </Dialog>
</template>
